import { REALTIME_PATH, serverMessageSchema, type ServerMessage } from '@netcon-work/shared'

export type Verbindungsstatus = 'verbindet' | 'verbunden' | 'getrennt'

/**
 * WebSocket-Verbindung mit automatischem Wiederaufbau.
 *
 * Hält den Client-Bestand aktuell (Leitplanke 2). Der Verbindungsstatus wird
 * nach außen gegeben, weil die Oberfläche ihn anzeigt – der Nutzer soll sehen,
 * wenn er veraltete Daten betrachtet.
 */
/**
 * **Steht der Live-Kanal gerade?** (15.10.2026) – für `nebenBestandVerwerfen`: Nur wenn er steht,
 * kommt die Bestätigung einer eigenen Aktion als `aufgabe.geaendert` und flickt den Bestand. Ist er
 * getrennt, muss nach einer Aktion der Bestand selbst neu geholt werden.
 */
let liveKanalSteht = false
export function liveKanalVerbunden(): boolean {
  return liveKanalSteht
}

export function connectRealtime(
  onMessage: (message: ServerMessage) => void,
  onStatus: (status: Verbindungsstatus) => void,
): () => void {
  let socket: WebSocket | undefined
  let versuch = 0
  let geschlossen = false
  let timer: number | undefined

  const verbinden = (): void => {
    if (geschlossen) return
    onStatus('verbindet')

    const protokoll = location.protocol === 'https:' ? 'wss:' : 'ws:'
    socket = new WebSocket(`${protokoll}//${location.host}${REALTIME_PATH}`)

    socket.onopen = () => {
      versuch = 0
      liveKanalSteht = true
      onStatus('verbunden')
    }

    socket.onmessage = (event) => {
      try {
        const parsed = serverMessageSchema.safeParse(JSON.parse(String(event.data)))
        if (parsed.success) onMessage(parsed.data)
      } catch {
        // Unlesbare Nachricht überspringen – kein Grund, die Verbindung zu kappen.
      }
    }

    socket.onclose = () => {
      liveKanalSteht = false
      onStatus('getrennt')
      if (geschlossen) return
      // Wiederaufbau mit steigendem Abstand, höchstens 15 s.
      const wartezeit = Math.min(500 * 2 ** versuch++, 15_000)
      timer = window.setTimeout(verbinden, wartezeit)
    }

    socket.onerror = () => socket?.close()
  }

  verbinden()

  return () => {
    geschlossen = true
    if (timer) window.clearTimeout(timer)
    socket?.close()
  }
}
